export default {
  kicker: 'Mehr',
  title: 'Ausrüstung',
  loading: 'Lädt …',
  loadError: 'Ausrüstung nicht geladen: {error}',
  active: 'Aktiv',
  retired: 'Ausgemustert',
  empty: 'Noch keine Schuhe. Lege einen an – oder importiere deinen Strava-Export.',
  add: 'Neuer Schuh',
  edit: 'Bearbeiten',
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  deleteConfirm: {
    one: 'Löschen nimmt den Schuh aus {count} Aktivität. Sie zählt dann ohne Schuh und wird nicht noch einmal abgefragt. Das lässt sich nicht rückgängig machen – wer die km behalten will, mustert aus.',
    other: 'Löschen nimmt den Schuh aus {count} Aktivitäten. Sie zählen dann ohne Schuh und werden nicht noch einmal abgefragt. Das lässt sich nicht rückgängig machen – wer die km behalten will, mustert aus.',
  },
  deleteYes: 'Endgültig löschen',
  retire: 'Ausmustern',
  unretire: 'Zurückholen',
  retireHint: 'Ausmustern: Der Schuh bleibt mit seinen km im Archiv, wird aber nicht mehr angeboten und warnt nicht mehr.',
  unretireHint: 'Zurückholen: Der Schuh wird wieder angeboten und warnt wieder.',
  name: 'Name',
  namePlaceholder: 'z. B. HOKA Clifton 9',
  startKm: 'km vorher',
  startKmHelp: 'Schon gelaufen, bevor dashy-dash den Schuh kannte',
  warnKm: '„Bald ersetzen" ab km',
  limitKm: '„Ersetzen" ab km',
  limitHelp: 'Laufschuhe halten meist 500–800 km. Leer = keine Grenze.',
  noLimit: 'leer = keine',
  counts: 'Gezählt werden Laufen, Gehen und Wandern mit dem Schuh, dazu die km vorher.',
  uses: { one: '{count} Aktivität', other: '{count} Aktivitäten' },
  range: 'gelaufen {from} – {to}',
  ofStart: 'davon {km} vorher',
  retiredOn: 'ausgemustert {date}',
  unused: 'noch nicht benutzt',
  status: { warn: 'Bald ersetzen', limit: 'Ersetzen' },
  toWarn: 'noch {km} bis „Bald ersetzen" ({at})',
  toLimit: 'noch {km} bis „Ersetzen" ({at})',
  overLimit: '{km} über {at}',
  retiredShow: { one: 'Ausgemustert ({count}) anzeigen', other: 'Ausgemustert ({count}) anzeigen' },
  ask: {
    title: 'Nach dem Lauf fragen',
    sub: 'Hat ein neuer Lauf keinen Schuh, fragt „Heute" nach – auf Wunsch auch per Push.',
    on: 'An',
    off: 'Aus',
  },
  push: {
    title: 'Push auf diesem Gerät',
    on: 'Ausschalten',
    off: 'Einschalten',
    sub: 'Nach einem neuen Lauf ohne Schuh kommt eine Nachricht, sonst nichts.',
    test: 'Testnachricht',
    testSent: 'Gesendet.',
    devices: { one: '{count} Gerät angemeldet', other: '{count} Geräte angemeldet' },
    unsupported: 'Dieser Browser kann keine Push-Nachrichten.',
    install: 'Auf dem iPhone geht Push erst, wenn dashy-dash installiert ist (siehe oben).',
    denied: 'Benachrichtigungen sind im Browser gesperrt – in den Website-Einstellungen erlauben.',
    hint: 'Android zeigt die zwei zuletzt genutzten Schuhe als Knöpfe in der Nachricht; auf dem iPhone öffnet ein Tipp die Karte.',
  },
  install: {
    title: 'Als App installieren',
    button: 'Installieren',
    prompt: 'Startet dann wie eine App, ohne Adressleiste.',
    done: 'Installiert – ab jetzt über das neue Symbol öffnen.',
    ios1: 'In Safari unten in der Leiste auf „Teilen" tippen:',
    ios2: 'In der Liste „Zum Home-Bildschirm" wählen (eventuell etwas nach unten wischen).',
    ios3: 'Oben rechts auf „Hinzufügen" tippen.',
    ios4: 'dashy-dash über das neue Symbol öffnen. Push für die Schuh-Frage dann unter „Ausrüstung" einschalten.',
    cardTitle: 'dashy-dash als App',
    why: 'Auf dem Home-Bildschirm startet dashy-dash wie eine App, ohne Adressleiste – und kann nach dem Lauf per Push nach dem Schuh fragen.',
    dismiss: 'Nicht mehr zeigen',
    shareIcon: 'Teilen-Symbol: Quadrat mit Pfeil nach oben',
    android: 'In Chrome oben rechts auf ⋮ tippen, dann „App installieren" oder „Zum Startbildschirm hinzufügen". Push geht auch ohne, direkt im Browser.',
    desktop: 'In Chrome oder Edge rechts in der Adressleiste auf das Installieren-Symbol klicken; in Safari am Mac Ablage → „Zum Dock hinzufügen".',
  },
  prompt: {
    title: 'Welcher Schuh?',
    skip: 'Ohne Schuh',
    later: 'Später fragen',
    more: { one: 'Danach fragt die Karte noch nach {count} Lauf.', other: 'Danach fragt die Karte noch nach {count} Läufen.' },
    otherAnswers: 'Oder:',
    saved: '{name} eingetragen',
  },
  activity: {
    label: 'Schuh',
    none: 'Keiner',
    manage: 'Ausrüstung',
  },
};
